import { render, staticRenderFns } from "./FilesAppSettingsLegacyApiEntry.vue?vue&type=template&id=6d8612e1"
import script from "./FilesAppSettingsLegacyApiEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesAppSettingsLegacyApiEntry.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports